import { css } from 'emotion'
// import {
//   NEUTRAL_BORDER_COLOR_LIGHT,
//   NEUTRAL_HIGH_LIGHT_COLOR,
// } from 'constants/styleConstants'

export const TaskFileCardStyles = css``
